/*

Copyright Paul B. Lucas (C) 2025, 2026   ALL RIGHTS RESERVED.
Licensed to the University of Illinois Urbana Champaign


Revisions:
    02/23/2025      pblucas     initial creation
    03/07/2025      pblucas     added three new routes: createAsset, deployAsset, recoverAsset
 
*/

import { createRouter, createWebHistory } from 'vue-router'
import RequestLoan                        from '@/views/Agreements/RequestLoan.vue'
import ListMyAgreements                   from '@/views/Agreements/ListMyAgreements.vue'
import ListMyAssets                       from '@/views/Assets/ListMyAssets.vue'
import ListAgreements                     from '@/views/Agreements/ListAgreements.vue'
import ListAssets                         from '@/views/Assets/ListAssets.vue'
import ListAuditableAssets                from '@/views/Assets/ListAuditableAssets.vue'
import ListEmployees                      from '@/views/Employees/ListEmployees.vue'
import ViewEditMe                         from '@/views/Employees/ViewEditMe.vue'
import Home                               from '@/views/Home.vue'
import About                              from '@/views/About.vue' 
import Logout                             from '@/views/Logout.vue'
import Settings                           from '@/views/Settings.vue'

import CreateAsset                        from '@/views/Assets/CreateAsset.vue'   
import DeployAssets                       from '@/views/Assets/DeployAssets.vue' 
import RecoverAssets                      from '@/views/Assets/RecoverAssets.vue'
import AssetsDisposition                  from '@/views/Assets/AssetsDisposition.vue'
import UnitDeployAssets                   from '@/views/Assets/UnitDeployAssets.vue'
import UnitRecoverAssets                  from '@/views/Assets/UnitRecoverAssets.vue'
import UnitDisposition                    from '@/views/Assets/UnitDisposition.vue'

const routes = [
  {
    // code is Entra user authentication code passed in from redirect
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/me/request',
    name: 'requestLoan',
    component: RequestLoan
  },
  {
    path: '/me/data',
    name: 'viewMyData',
    component: ViewEditMe
  },
  {
    path: '/me/myAgreements',
    name: 'listMyAgreements',
    component: ListMyAgreements
  },
  {
    path: '/me/myAssets',
    name: 'listMyAssets',
    component: ListMyAssets
  },
  {
    path: '/agreements',
    name: 'listAgreements',
    component: ListAgreements
  },
  {
    path: '/assets',
    name: 'listAssets',
    component: ListAssets
  },
  {
    path: '/assets/audit',
    name: 'listAuditableAssets',
    component: ListAuditableAssets
  },
  {
    path: '/assets/create',
    name: 'createAsset',
    component: CreateAsset
  },
  {
    path: '/assets/deploy',
    name: 'deployAssets',
    component: DeployAssets
  },
  {
    path: '/assets/recover',
    name: 'recoverAssets',
    component: RecoverAssets
  },
  {
    path: '/assets/dispose',
    name: 'disposition',
    component: AssetsDisposition
  },
  {
    path: '/assets/unit/deploy',
    name: 'unitDeploy',
    component: UnitDeployAssets
  },
  {
    path: '/assets/unit/recover',
    name: 'unitRecover',
    component: UnitRecoverAssets
  },
  {
    path: '/assets/unit/dispose',
    name: 'unitDisposition',
    component: UnitDisposition
  },
  {
    path: '/employees',
    name: 'listEmployees',
    component: ListEmployees
  },
  {
    path: '/about',
    name: 'about',
    component: About
  },
  {
    path: '/settings',
    name: 'settings',
    component: Settings
  },
  {
    path: '/logout',
    name: 'logout',
    component: Logout
  }  
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
